export const CHANNELINFO_LIST = 'CHANNELINFO_LIST';
export const CHANNELINFO_LIST_SUCCESS = 'CHANNELINFO_LIST_SUCCESS';
export const CHANNELINFO_LIST_ERROR = 'CHANNELINFO_LIST_ERROR';

export const CHANNELINFO_DETAILS = 'CHANNELINFO_DETAILS';

export const CHANNELWIDTH_DETAILS = 'CHANNELWIDTH_DETAILS';

export const CHANNEL_CONVERTION_DETAILS = 'CHANNEL_CONVERTION_DETAILS';

export const CHANNEL_MATRICS_DETAILS = 'CHANNEL_MATRICS_DETAILS';

export const MODEL_NAMES = 'MODEL_NAMES';

export const GET_TERRAIN = 'GET_TERRAIN';
export const GET_TERRAIN_SUCCESS = 'GET_TERRAIN_SUCCESS';
export const GET_TERRAIN_ERROR = 'GET_TERRAIN_ERROR';

export const GET_EVENT_RULES = 'GET_EVENT_RULES';
export const GET_EVENT_RULES_SUCCESS = 'GET_EVENT_RULES_SUCCESS';
export const GET_EVENT_RULES_ERROR = 'GET_EVENT_RULES_ERROR';
export const GET_EVENT_RULES_DETAILS = 'GET_EVENT_RULES_DETAILS';

export const UPDATE_EVENT_COMPARISON = 'UPDATE_EVENT_COMPARISON';
export const UPDATE_EVENT_COMPARISON_SUCCESS = 'UPDATE_EVENT_COMPARISON_SUCCESS';
export const UPDATE_EVENT_COMPARISON_ERROR = 'UPDATE_EVENT_COMPARISON_ERROR';


export const UPDATE_IMG_CLASSIFICATION = 'UPDATE_IMG_CLASSIFICATION';
export const UPDATE_IMG_CLASSIFICATION_SUCCESS = 'UPDATE_IMG_CLASSIFICATION_SUCCESS';
export const UPDATE_IMG_CLASSIFICATION_ERROR = 'UPDATE_IMG_CLASSIFICATION_ERROR';

export const MULTIPLEMODEL_LIST = 'MULTIPLEMODEL_LIST';
export const MULTIPLEMODEL_LIST_SUCCESS = 'MULTIPLEMODEL_LIST_SUCCESS';
export const MULTIPLEMODEL_LIST_ERROR = 'MULTIPLEMODEL_LIST_ERROR';


export const UPDATE_SUBCHAINLIST = 'UPDATE_SUBCHAINLIST';
export const UPDATE_SUBCHAINLIST_SUCCESS = 'UPDATE_SUBCHAINLIST_SUCCESS';
export const UPDATE_SUBCHAINLIST_ERROR = 'UPDATE_SUBCHAINLIST_ERROR';

export const DATA_SOURCE_LIST = 'DATA_SOURCE_LIST';
export const DATA_SOURCE_LIST_SUCCESS = 'DATA_SOURCE_LIST_SUCCESS';
export const DATA_SOURCE_LIST_ERROR = 'DATA_SOURCE_LIST_ERROR';
